import type { ErrorInfo } from 'react';

export const addLog = () => {
    fetch(`/log/`);
}

export const logError = (err: unknown, info: ErrorInfo = { componentStack: '' }) => {
    console.error(err);
    if (info.componentStack) console.error(info.componentStack);
}
